import { useEffect, useState } from "react";
import { API } from "@/lib/api";

const OFFICIAL_LOGO = "/logo-iudp-360.png";

export const BrandMark = ({ hasLogo, version, className = "h-12", testId = "brand-logo" }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
  }, [version]);
  const src = hasLogo && !failed ? `${API}/public/logo?v=${version}` : OFFICIAL_LOGO;
  return (
    <img data-testid={testId} src={src} alt="Logomarca Igreja Unida Deus Proverá" onError={() => setFailed(true)}
      className={`w-auto shrink-0 object-contain ${className}`} />
  );
};

export const BrandLockup = ({ hasLogo, version, logoClass = "h-12", testId = "brand-lockup", compact = false }) => (
  <div data-testid={testId} className="flex min-w-0 items-center gap-2 min-[380px]:gap-3">
    <BrandMark hasLogo={hasLogo} version={version} className={logoClass} />
    <div className="min-w-0 border-l border-[#C9A24A]/40 pl-2 min-[380px]:pl-3">
      <p className="whitespace-nowrap font-display text-[17px] min-[380px]:text-[20px] font-semibold leading-tight tracking-wide text-white sm:text-[22px]">ZAP IUDP</p>
      <p className={`whitespace-nowrap font-medium uppercase text-[#E2C27A] ${compact ? "text-[11px] tracking-[0.08em]" : "text-[11px] tracking-[0.06em] min-[380px]:text-[13px] min-[380px]:tracking-[0.14em] sm:text-[14px]"}`}>Central Digital</p>
    </div>
  </div>
);
